import { CornerDotTypes } from "../types";

export default {
  dot: "dot",
  square: "square",
  heart: "heart"
} as CornerDotTypes;
